import React, { Component } from "react";
import DatePicker from "react-date-picker";
import Select from "react-select";
import axios from "axios";
import {optionsPagesa} from "../../variables/Modal"
import {menyrePagese} from "../../variables/Modal"
import {kodeProdukte} from "../../variables/Modal"
import moment from "moment";
import HmacSHA256 from "crypto-js/hmac-sha256";
import swal from "sweetalert";
import { CSVLink } from "react-csv";
import ReactTable from "react-table";
import LoadingSpinner from "../../components/Input/LoadingSpinner";
import {Modal} from "../../variables/Modal"
import {columns2} from "../../variables/Modal"

class RaportPodePadorezuar extends Component {
  state = {
    PNga: new Date(),
    PDeri: new Date(),
    date: new Date(),
    posts: [{}],
    postsexcel: [{}],
    username: window.UserP.username,
    dataPosts: [],
    Id: "",
    perdorues: "",
    terminal: [],
    data2: [],
    data3: [],
    txtAgjensi: true,
    checkedboxKP: false,
    Agjensi: window.UserP.agencyId,
    data4: [],
    data5: [],
    data6: [],
    ProcesorId: "",
    selectedOption: null,
    KushPaguan: optionsPagesa[2],
    KodiProduktit: kodeProdukte[4],
    MenyrePagese: { value: "True", label: "Te Gjitha" },
    KodLevizje: { value: "True", label: "Te Gjitha" },
    KlienteSubjekte: { value: "True", label: "Te Gjitha" },
    Pershkrimi: { value: "True", label: "Te Gjitha" },
    Origjina: { value: "True", label: "Te Gjitha" },
    showModal: false,
    show: false,
    
  };

  handleClear = () => {
    this.setState({
      date: "",
      pNga: new Date(),
      pDeri: new Date(),
      posts: [{}],
      terminal: [],
    });
  };
  handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value.toUpperCase() });
  };
  componentDidMount() {
    {
      fetch(window.UserP.url + "POD/GetPerdorues", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          Id: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data2: data }));
    }
    {
      fetch(window.UserP.url + "POD/GetKodeLevizje", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
           "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data3: data }));
    }
    {
      fetch(window.UserP.url + "POD/GetKodePershkrimi", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
           "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data4: data }));
    }
    {
      fetch(window.UserP.url + "POD/GetKlienteSubjekte", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
           "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data5: data }));
    }
    {
      fetch(window.UserP.url + "POD/GetAgjensi", {
        method: "Post",
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
           "Access-Control-Allow-Origin": "*"
        },
        body: JSON.stringify({
          Token: HmacSHA256(
            Math.round(new Date().getTime() / 1000).toString(),
            window.UserP.key
          ).toString(),
           username: this.state.username,
          agjensi: window.UserP.agencyId,
        }),
      })
        .then((res) => res.json())
        .then((data) => this.setState({ data6: data }));
    }
  }
  handleChangeCheckKP = (e) => {
    const { checked } = e.target
    this.setState({
      checkedboxKP: checked,
    })
    this.state.checkedboxKP = checked;
  };
  convertToDropDown = (par) => {
    var ret = [];
    var paramArray = par;

    for (var i in paramArray) {
      var objItem = { value: "", label: "" };
      objItem.value = paramArray[i];
      objItem.label = paramArray[i];
      ret.push(objItem);
    }

    return ret;
  };
  printfunction = () => {
    var windowName = "";
    var windowUrl = " ";
    var myWindow = window.open(
      windowUrl,
      windowName,
      "left=0,top=0,right=0,bottom=0 margin=0,0,0,0"
    );

    let test = this.state.posts;
    var test5 =
      "&nbsp" +
      // "<table >" +
      "<tr>" +
      "<th >" +
      "Agjensia: " +
      this.state.Agjensi +
      "<br>" +
      "<br>" +
      "</th>" +
      "<br>" +
      "<br>" +
      "<font face='calibri'" +
      ">" +
      "<br>" +
      "&nbsp" +
      "&nbsp" +
      "<br>" +
      "<br>" +
      "<b>" +
      "   </tr>" +
      "<table border='1' >" +
      "<thead>" +
      "<tr>" +
      "<th class='cell'>" +
      "Nr_POD" +
      "</th>" +
      " <th class='cell'>" +
      "Status" +
      "</th>" +
      // "<th class='-cell'>" +
      // "Origjina" +
      // "</th>" +
      "<th class='-cell'>" +
      "DataGR" +
      "</th>" +
      "<th class='-cell'>" +
      "DataStatus" +
      "</th>" +
      "<th class='-cell'>" +
      "M.Pagese" +
      "</th>" +
      "<th class='-cell'>" +
      "Kush Paguan" +
      "</th>" +
      "<th class='-cell'>" +
      "Derguesi" +
      "</th>" +
      "<th class='-cell'>" +
      "Vlera KP" +
      "</th>" +
      "<th class='-cell'>" +
      "Mon.KP" +
      "</th>" +
      "<th class='-cell'>" +
      "Totali" +
      "</th>" +
      "  </tr>" +
      "  </thead>" +
      "  <tbody>";

    for (var i = 0; i < test.length; i++) {
      let monedha="";
      if(test[i].Monedha_Kunder_Pagese =="5"){
        monedha = "LEKE";
      }else if (test[i].Monedha_Kunder_Pagese =="1") {
        monedha = "EURO";
      }
      else {
        monedha = "JO";
      }
      test5 +=
        "<tr class='firstRow'>" +
        "<td class='Nr_POD:-cell'>" +
        test[i].Nr_POD +
        "</td>" +
        " <td class='Status:-cell'>" +
        test[i].Arsye_Mosdorezimi +
        "</td>" +
        // " <td class='Origjina:-cell'>" +
        // test[i].Origjina +
        // "</td>" +
        " <td class='DataGR:-cell'>" +
        moment(test[i].Data).format("DD/MM/YYYY") +
        "</td>" +
        " <td class='DataStatus:-cell'>" +
        moment(test[i].DataStatus).format("DD/MM/YYYY") +
        "</td>" +
        " <td class='M.Pagese:-cell'>" +
        test[i].Menyre_Pagese +
        "</td>" +
        " <td class='Kush Paguan:-cell'>" +
        test[i].Kush_Paguan +
        "</td>" +
        " <td class='Derguesi:-cell'>" +
        test[i].Derguesi +
        "</td>" +
        " <td class='Vlera KP:-cell'>" +
        test[i].Vlera_Kunder_Pagese +
        "</td>" +
        " <td class='Mon.KP:-cell'>" +
        monedha +
        "</td>" +
        " <td class='Totali:-cell'>" +
        test[i].Totali +
        "</td>" +
        " </tr>" +
        "&nbsp" +
        "&nbsp" +
        "   </tr>";
    }

    test5 +=
      "<th >" +
      "Total Kundrejt Pagese Leke : " +
      "0.2" +
      "<br>" +
      "<br>" +
      "</th>" +
      "<th >" +
      "Total Kundrejt Pagese Euro: " +
      "0.1" +
      "<br>" +
      "<br>" +
      "</th>" +
      "  </tbody>" +
      "</table>" +
      "</font>";
      //console.log(test5);
    myWindow.document.write(test5);
    myWindow.focus();
    myWindow.print();
  };

  handleClick = (e) => {
    const RaportReq = {
      Origjina: this.state.Origjina.label,
      KushPaguan: this.state.KushPaguan.label,
      KodLevizje: this.state.KodLevizje.label,
      MenyrePagese: this.state.MenyrePagese.label,
      Agjensi: window.UserP.agencyId,
      KlienteSubjekte: this.state.KlienteSubjekte.label,
      KodiProduktit: this.state.KodiProduktit.label,
      Pershkrimi: this.state.Pershkrimi.label,
      PNga: moment(this.state.PNga).format("MM/DD/YYYY"),
      PDeri: moment(this.state.PDeri).format("MM/DD/YYYY"),
      KundrejtPageseCheck: this.state.checkedboxKP,
      username: this.state.username,
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),
    };
  
    axios
      .post(window.UserP.url + "POD/LogPodPaDorezuar", RaportReq)
      .then((response) => {
        this.setState({
          posts: response.data,
        });
        //console.log(this.state.posts);
        this.printfunction();
        
        // let valueAdded = 0;
        // let vleraPakos = 0;
        // let totalLek = 0;

        // for (var i = 0; i < this.state.posts.length; i++) {
        //   //count1 = parseInt(this.state.posts[i].Cmimi_Baze);
        //   valueAdded += parseFloat(this.state.posts[i].Cmimi_Baze);
        //   vleraPakos += parseFloat(this.state.posts[i].VleraKP);
        // }
        // totalLek = valueAdded + vleraPakos;
        // this.setState({
        //   TotalVP: this.thousands_separators(valueAdded.toFixed(2)),
        //   TotalKP: this.thousands_separators(vleraPakos.toFixed(2)),
        //   TotalLek: this.thousands_separators(totalLek.toFixed(2))
        // });
      
      });
  };

  handleClickSearch = (e) => {
    const RaportReq = {
      Origjina: this.state.Origjina.label,
      KushPaguan: this.state.KushPaguan.label,
      KodLevizje: this.state.KodLevizje.label,
      MenyrePagese: this.state.MenyrePagese.label,
      Agjensi: window.UserP.agencyId,
      KlienteSubjekte: this.state.KlienteSubjekte.label,
      KodiProduktit: this.state.KodiProduktit.label,
      Pershkrimi: this.state.Pershkrimi.label,
      PNga: moment(this.state.PNga).format("MM/DD/YYYY"),
      PDeri: moment(this.state.PDeri).format("MM/DD/YYYY"),
      KundrejtPageseCheck: this.state.checkedboxKP,
      username: this.state.username,
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),
    };
  
    axios
      .post(window.UserP.url + "POD/LogPodPaDorezuar", RaportReq)
      .then((response) => {
        this.setState({
          posts: response.data,
          postsexcel:[] 
        });

         for (var i = 0; i < this.state.posts.length; i++) {
            if(this.state.posts[i].Monedha_Kunder_Pagese =="5"){
        this.state.posts[i].Monedha_Kunder_Pagese = "LEKE";
      }else if (this.state.posts[i].Monedha_Kunder_Pagese =="1") {
        this.state.posts[i].Monedha_Kunder_Pagese = "EURO";
      }
      else {
        this.state.posts[i].Monedha_Kunder_Pagese = "JO";
      }
            

            const dataexcel = {
              Nr_POD:this.state.posts[i].Nr_POD.toString().trim(),
              Status:this.state.posts[i].Arsye_Mosdorezimi.toString().trim(),
              //Origjina:this.state.posts[i].Origjina.toString().trim(),
              DataGR:this.state.posts[i].Data.toString().trim(),
               DataStatus:this.state.posts[i].DataStatus.toString().trim(),
              Menyre_Pagese:this.state.posts[i].Menyre_Pagese.toString().trim(),
              Kush_Paguan:this.state.posts[i].Kush_Paguan.toString().trim(),
              Derguesi:this.state.posts[i].Derguesi.toString().trim(),
              Vlera_Kunder_Pagese:this.state.posts[i].Vlera_Kunder_Pagese.toString().trim(),
              Monedha_Kunder_Pagese:this.state.posts[i].Monedha_Kunder_Pagese.toString().trim(),
              Totali:this.state.posts[i].Totali.toString().trim(),
            }

            this.state.postsexcel.push(dataexcel);
          }

          this.setState({
            postsexcel: this.state.postsexcel
          });
      
      });
  };

  showModal = () => {
    this.setState({ show: true });
  };
  hideModal = () => {
    this.setState({ show: false });
  };

  handleClickGjurmo = (e) => {
    this.showModal();
    var d = new Date();
    const data = {
      nrKodi: e,
      Token: HmacSHA256(
        Math.round(new Date().getTime() / 1000).toString(),
        window.UserP.key
      ).toString(),

      username: window.UserP.username,
    };

    const headers = {
      Accept: "application/json",
      "Content-type": "application/json",
      "Access-Control-Allow-Origin": "*",
    };

    axios.post(window.UserP.url + "POD/Gjurmo", data).then((response) => {
      this.setState({ dataPosts: response.data });
    });
  };

  handleChange = (value) => {
    this.setState({
      PNga: value,
    });
  };

  handleChange1 = (value) => {
    this.setState({
      PDeri: value,
    });
  };
  onChangeFunc = (name) => (value) => {
    // console.log(value.label);
    this.setState({
      [name]: value,
    });
  };

  render() {
    const columns = [
      {
        Header: "Nr",

        id: "row",
        filterable: false,
        Cell: (row) => {
          return <div>{row.index + 1}</div>;
        },
      },
      {
        Header: "Nr.POD",
        accessor: "Nr_POD",
        maxWidth: 400,
        minWidth: 140,
        width: 200,

        //  Cell: e => <a href={e.value}>{(onClick = this.showModal())}</a>
        Cell: (cell) => (
          <span
            style={{
              cursor: "pointer",
              color: "blue",
              textDecoration: "underline",
            }}
            onClick={() => this.handleClickGjurmo(cell.value)}
          >
            {cell.value}
          </span>
        ),
      },
      {
        Header: "Status",
        accessor: "Arsye_Mosdorezimi",
      },
      {
        Header: "Data Grumbullim",
        accessor: "Data",
      },
      // {
      //   Header: "Origjina",
      //   accessor: "Origjina",
      // },
      {
        Header: "DataStatus",
        accessor: "DataStatus",
      },
      {
        Header: "Menyre Pagese",
        accessor: "Menyre_Pagese",
      },
      {
        Header: "Kush Paguan",
        accessor: "Kush_Paguan"
      },
      {
        Header: "Derguesi",
        accessor: "Derguesi",
      },
      {
        Header: "Vlera KP",
        accessor: "Vlera_Kunder_Pagese",
      },
      {
        Header: "Monedha KP",
        accessor: "Monedha_Kunder_Pagese",
      },
      {
        Header: "Totali",
        accessor: "Totali",
      }
    ];
    return (
      <div className="Form2">
        <div className="card card-body bg-light col-md-12">
          <div className="row ">
            <div className="col-md-2">
              <label className="">Mos Dorezuar nga:</label>
            </div>
            <div className="col-md-2">
              <input
                className="form-control input-sm"
                value={this.state.Agjensi}
                type="text"
                //   onChange={e => this.handleInputChange(e, "Agjensi")}
                disabled={this.state.txtAgjensi}
              />
            </div>
            <div className="col-md-2">
              <label>Origjina</label>
            </div>
            <div className="col-md-2">
              <Select
                onChange={this.onChangeFunc("Origjina")}
                options={this.convertToDropDown(this.state.data6)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
            <div className="col-md-2">
              <label>Kush Paguan</label>
            </div>
            <div className="col-md-2">
              <Select
                className=""
                value={this.state.KushPaguan}
                onChange={this.onChangeFunc("KushPaguan")}
                options={optionsPagesa}
                defaultValue={optionsPagesa[2]}
              />
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-md-2">
              <label className="">Kodi Produktit</label>
            </div>
            <div className="col-md-2">
              <Select
                className="custom-Select "
                onChange={this.onChangeFunc("KodiProduktit")}
                options={kodeProdukte}
                defaultValue={kodeProdukte[4]}
              />
            </div>
            <div className="col-md-2">
              <label>Kodi Levizjes</label>
            </div>
            <div className="col-md-2">
              <Select
                className=""
                onChange={this.onChangeFunc("KodLevizje")}
                options={this.convertToDropDown(this.state.data3)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
            <div className="col-md-2">
              <label>Kliente Subjekte</label>
            </div>
            <div className="col-md-2">
              <Select
                className="custom-Select"
                //value={this.state.kushPaguan}
                onChange={this.onChangeFunc("KlienteSubjekte")}
                options={this.convertToDropDown(this.state.data5)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
          </div>
          <div className="row mt-1">
            <div className="col-md-2">
              <label className="">Pershkrimi</label>
            </div>
            <div className="col-md-2">
              <Select
                className="custom-Select"
                //value={this.state.kushPaguan}
                onChange={this.onChangeFunc("Pershkrimi")}
                options={this.convertToDropDown(this.state.data4)}
                defaultValue={{ value: "True", label: "Te Gjitha" }}
              />
            </div>
            <div className="col-md-2">
              <label>Menyre Pagese</label>
            </div>
            <div className="col-md-2">
              <Select
                className="custom-Select"
                onChange={this.onChangeFunc("MenyrePagese")}
                options={menyrePagese}
                defaultValue={menyrePagese[2]}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              {' '}
            </div>
            <div className="col-md-2">
             <label className="mt-3">KP(Leke)</label>
            </div>
            <div className="col-md-1 mt-2">
                              <label class="checkboxcontainer mt-sm-1 ml-md-1">
                           <input
                              id="26"
                              type="checkbox"
                              name="test"
                              onChange={e =>this.handleChangeCheckKP(e)}
                              defaultChecked={this.state.checkedboxKP}
                              
                            />
                            <span class="checkmark"></span>
                            </label> 
                            </div>
          </div>
        
          <div className="row mt-5">
          <div className="card card-body bg-light col-md-12">
            <div className="row"> 
            <div className="col-md-3 ">
              <label className="">Nga</label>
            </div>
            <div className="col-md-3 ">
              <DatePicker
                locale="en-NZ"
                className="float-left"
                onChange={this.handleChange}
                value={this.state.PNga}
                name="PNga"
                dateFormat="Pp"
              />
            </div>

            <div className="col-md-3">
              <label className="">Deri</label>
            </div>
            <div className="col-md-3">
              <DatePicker
                locale="en-NZ"
                onChange={this.handleChange1}
                value={this.state.PDeri}
                name="PDeri"
                dateFormat="Pp"
              />
            </div>
          </div></div></div>
          <div className="row mt-4">
            <div className="col-md-3">
              <button
                onClick={() => this.handleClick()}
                className="btn btn-primary "
              >
                <span data-notify="icon" className="pe-7s-print" />
                &nbsp; Printo
              </button>
            </div>
            <div className="col-md-3">
              <button
                onClick={() => this.handleClickSearch()}
                className="btn btn-primary "
              >
                <span data-notify="icon" className="pe-7s-print" />
                &nbsp; Kerko
              </button>
            </div>
            <div className="col-md-3">
            <CSVLink className="mt-4 float-left" data={this.state.postsexcel}>
              <span data-notify="icon" className="pe-7s-download" />
              &nbsp; Eksporto
            </CSVLink>
            </div>
            <div className="col-md-3">
              <button
                className="btn btn-primary float-right"
                // type="submit"
                onClick={this.handleClear}
              >
                <span data-notify="icon" className="pe-7s-trash" />
                &nbsp; Pastro
              </button>
            </div>
          </div>
          <div>
          {this.state.loading ? (
            <LoadingSpinner />
          ) : (
            <div className="row mt-2">
              <div className="col-md-12 ">
                <ReactTable
                  columns={columns}
                  data={this.state.posts}
                  defaultPageSize={10}
                  className="-striped -highlight mt-4"
                  pageText="Faqe"
                  nextText="Para"
                  rowsText="Rreshta"
                  previousText="Mbrapa"
                  noDataText="Nuk ka te dhena"
                />
              </div>
            </div>
          )}
          </div>
        </div>
        <Modal show={this.state.show} handleClose={this.hideModal}>
          <div>
            <div className="row" />
            <div />{" "}
            {this.state.loading ? (
              <LoadingSpinner />
            ) : (
              <div className="card card-body bg-light col-md-9 mt-4">
                <ReactTable
                  columns={columns2}
                  data={this.state.dataPosts}
                  defaultPageSize={10}
                  className="-striped -highlight mt-4"
                  pageText="Faqe"
                  nextText="Para"
                  rowsText="Rreshta"
                  previousText="Mbrapa"
                  noDataText="Nuk ka te dhena"
                />
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

export default RaportPodePadorezuar;
